import { gql } from '@apollo/client';

export const DELETE_TEMPLATE = gql`
  mutation DeleteLibraryTemplate($input : DeleteLibraryTemplateInput!) {
    deleteLibraryTemplate(input: $input) {
      id
    }
  }
`;